<script>
import {Icon} from '@iconify/vue';
import sidebarMixin from '../../../mixins/sidebarMixin';
import VueLoadImage from 'vue-load-image';

export default {
  components: {'vue-load-image': VueLoadImage, Icon},
  mixins: [sidebarMixin],
  props: {
    md5: {
      type: String,
      required: false,
    },
    height: {
      type: Number,
      required: false,
      default: undefined,
    },
    cover: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: undefined,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    physical: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    laundry: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    radius: {
      type: [String],
      required: false,
      default: '',
    },
    rating: {
      type: Object,
      required: false,
      default: undefined,
    },
    disabledLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    targetBlank: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    urlPictureOnly() {
      if (this.md5) {
        let url = import.meta.env.VUE_APP_PUBLIC_API_URL + '/picture/' + this.md5;
        if (this.small || this.isSmallHeight) {
          url += '/small';
        } else if (this.isMediumHeight) {
          url += '/medium';
        }
        return url;
      }
      return undefined;
    },

    urlPicture() {
      if (this.md5) {
        let url = import.meta.env.VUE_APP_PUBLIC_API_URL + '/picture/' + this.md5;
        if (this.small || this.isSmallHeight) {
          url += '/small';
        } else if (this.isMediumHeight) {
          url += '/medium';
        }
        return {
          background: 'url(' + url + ')',
          'background-position': 'center',
          'background-size': 'cover',
          'border-radius': this.radius + 'px',
        };
      }
      return {background: 'url(' + require('@/assets/avatar.jpg') + ')', 'border-radius': this.radius + 'px'};
    },
    heightStyle() {
      if (this.cover && this.height) {
        return {width: '100%', height: this.height + 'px', 'border-radius': this.radius + 'px'};
      } else if (this.height) {
        return {height: this.height + 'px', 'border-radius': this.radius + 'px'};
      } else {
        return {height: '100%', 'border-radius': this.radius + 'px'};
      }
    },
    isSmallHeight() {
      return this.height != null && this.height < 100;
    },
    isMediumHeight() {
      return this.height != null && this.height >= 100 && this.height <= 200;
    },
  },
  methods: {
    onClick() {
      if (this.disabledLink) return;
      this.hideSidebar();
    },
  },
};
</script>

<template>
  <!-- Composant dynamique pour désactiver la redirection si la propriété disabledLink est à true -->
  <component
    :target="targetBlank ? '_blank' : null"
    :is="disabledLink ? 'div' : 'router-link'"
    @click="onClick"
    :to="{name: 'accommodationPage', params: {accommodationId: id}}"
    class="w-full flex justify-center">
    <div class="picture-accommodation relative" v-bind:style="heightStyle">
      <vue-load-image class="w-full h-full flex items-center justify-center overflow-hidden" :class="this.radius">
        <template v-slot:image>
          <div class="pictures-acc" v-bind:style="urlPicture" :data-src="urlPictureOnly" />
        </template>
        <template v-slot:preloader>
          <img :src="require('@/assets/loader.gif')" class="w-[100px] max-w-full" />
        </template>
        <template v-slot:error>
          <img :src="require('@/assets/placeholder_image.svg')" class="w-full h-full object-cover" />
        </template>
      </vue-load-image>

      <div v-if="name" class="flex gap-2 items-center absolute bottom-[10px] left-[10px] rounded-[6px] bg-white p-2">
        <i class="ga-icon ga-hand_key text-grey-900 text-base" v-if="physical"></i>
        <i class="ga-icon ga-shirt_cleaning text-grey-900 text-base" v-if="laundry"></i>
        <span class="font-inter text-grey-900 font-semibold text-sm">{{ name }}</span>
      </div>

      <router-link
        v-if="rating"
        :to="{
          name: 'accommodationPage',
          params: {accommodationId: id},
          hash: '#accommodationReviews',
        }">
        <div class="flex flex-col items-center absolute top-[10px] right-[10px] rounded-[10px] bg-white p-2">
          <span class="font-inter text-grey-900 font-bold text-md flex gap-1 items-center">
            <Icon icon="ic:round-star" width="22px" color="#F2CC5D" />
            {{ rating.rating }}
          </span>
          <span class="font-inter text-grey-300 text-sm font-semibold">{{ rating.nbReviews }} avis</span>
        </div>
      </router-link>
    </div>
  </component>
</template>
